export const sizeMap = {
  default: 'small',
  mini: 'mini'
};
